module.exports = __webpack_public_path__ + "img/header-bar.4b35da06.png";